export const CAT_SECTIONS = [
    {
        cat: 'assessment',
        desc: 'Offer assessment packages and take orders from ATS swith one API and unified data models',
        code: `POST /assessment/{connection_id}/package

    name: "Jane Smith",
    description: "International background checking",
    price: 100,
}`,
    },
    {
        cat: 'calendar',
        desc: 'List, Get, Update, Create, Delete, and Associate <b>Events</b>, <b>FreeBusy</b>, <b>Meetings</b>, <b>Recurring Events</b>, <b>Schedules</b>, <b>Scheduling Links</b>, <b>Transcripts</b>, and <b>Users</b> with one API and unified data models',
        code: `GET /calendar/{connection_id}/event
    },
    {
        id: "12345",
        name: "Jane Smith",
    }`,
    },
    {
        cat: 'crm',
        desc: `List, Get, Update, Create, Delete, and Associate <b>Contacts</b>, <b>Deals</b>, <b>Companies</b>, <b>Events</b>, <b>Teams</b>, <b>Users</b>, <b>Files</b>, <b>Pipelines</b>, and <b>Leads</b> with one API and unified data models`,
        code: `GET /crm/{connection_id}/contact

[
    {
        id: "12345",
        name: "Jane Smith",
        emails: ["jsmith@gmail.com"],
        ...
    }
]`,
    },
    ,
    {
        cat: 'shipping',
        desc: `List, Get, Update, and Calculate <b>Rates</b>, <b>Shipments</b>, <b>Labels</b>, <b>Carriers</b> and <b>Tracking</b> with one API and unified data models`,
        code: `GET /shipping/{connection_id}/rate

{
    id: 12345,
    from_address: {
        name: "John Smith",
        address: "123 Main St, Anytown, USA",
        city: "Anytown",
        state: "CA",
        zip: "12345",
        country: "USA",
    },
    to_address: {
        name: "Jane Smith",
        address: "456 Main St, Anytown, USA",
        city: "Anytown",
        state: "CA",
        zip: "12345",
        country: "USA",
    },
    ...
}`,
    },
    {
        cat: 'martech',
        desc: 'List, Get, Update, Create, Delete, and Associate <b>Members</b>, and <b>Lists</b> with one API and unified data models',
        code: `POST /martech/{connection_id}/{list_id}/member

{
    id: "12345",
    name: "Jane Smith",
    emails: ["jsmith@gmail.com"],
    tags: ["optedin"],
    listIds: ["23456", "34567"],
    ...
}`,
    },
    {
        cat: 'ticketing',
        desc: 'List, Get, Update, Create, and Delete <b>Customers</b>, <b>Agents</b> and <b>Tickets</b> with one API and unified data models',
        code: `POST /ticketing/{connection_id}/customer

{
    id: "12345",
    name: "John Smith",
    emails: ["johnsmith@gmail.com"],
    tags: ["vip"],
    ...
}`,
    },
    {
        cat: 'enrich',
        desc: 'Enrich <b>Users</b> and <b>Companies</b> with one API and unified data models',
        code: `GET /enrich/{connection_id}/person?email=elon@spacex.com

{
    name: "Elon Musk",
    telephones: ["+1-555-123-4567"],
    title: "CEO",
    ...
}`,
    },
    {
        cat: 'uc',
        desc: 'List, Get, Update, Create, Delete, and Associate <b>Contacts</b>, <b>Calls</b> and <b>Agents</b> with one API and unified data models',
        code: `GET /uc/{connection_id}/call

{
    id: 12345,
    contactId: 23456,
    agentId: 34567,
    startTime: "09:00",
    endTime: "09:17",
    ...
}`,
    },
    {
        cat: 'ats',
        desc: 'List, Get, Update, Create, and Delete <b>Candidates</b>, <b>Jobs</b>, <b>Interviews</b>, and <b>Documents</b> with one API and unified data model',
        code: `GET /ats/{connection_id}/candidate

{
    id: 12345,
    name: 'John Smith',
    emails: [ { email: 'john@foobar.com' } ]
    ...
}`,
    },
    {
        cat: 'hris',
        desc: 'List, Get, Update, Create, and Delete <b>Employees</b> and <b>Groups</b> with one API and unified data models',
        code: `GET /hris/{connection_id}/employee

{
    id: 12345,
    name: 'John Smith',
    emails: [ { email: 'john@foobar.com' } ]
    ...
}`,
    },
    {
        cat: 'accounting',
        desc: 'List, Get, Update, Create, and Delete <b>Transactions</b> and <b>Invoices</b> with one API and unified data models',
        code: `GET /accounting/{connection_id}/invoice

{
    id: 12345,
    ...
}`,
    },
    {
        cat: 'commerce',
        desc: 'List, Get, Update, Create, and Delete <b>Items</b> and <b>Inventories</b> with one API and unified data models',
        code: `GET /commerce/{connection_id}/item

{
id: 12345,
name: 'Red hat',
...
}`,
    },
    {
        cat: 'payment',
        desc: 'List, Get, Update, Create, and Delete <b>Payments</b> and <b>Refunds</b> with one API and unified data models',
        code: `GET /payment/{connection_id}/refund

    {
    id: 12345,
    amount: 100.45
    ...
    }`,
    },
    {
        cat: 'auth',
        desc: 'Sign-in a user</b> to return an email and name after a successful OAUTH2 authorization',
        code: `GET /auth/{connection_id}/login

https://accounts.google.com/o/oauth2/v2/auth?client_id=12345&scope=profile&response_type=code&redirect_uri=https%3A//oauth2.example.com/code`,
    },
    {
        cat: 'storage',
        desc: '',
        code: `GET /storate/{connection_id}/file

[
  {
    id: '12345',
    name: 'file.doc',
    size: 64
    ...
  }
]`,
    },
    {
        cat: 'genai',
        desc: '',
        code: `POST /genai/{connection_id}/prompt

{
    model_id: "gpt-4o",
    messages: [
        ...
    ],
    temperature: 0.8,
    max_tokens: 1000,
    ...
}`,
    },
    {
        cat: 'messaging',
        desc: 'Read <b>Messages</b> and <b>Channels</b> with one API and unified data models',
        code: `GET /messaging/{connection_id}/message

{
    channel_id: "F0746S9DU3E",
    message: "hello world!",
    ...
}`,
    },
    {
        cat: 'kms',
        desc: 'Read <b>Spaces</b> and <b>Pages</b> with one API and unified data models',
        code: `GET /kms/{connection_id}/page

{
    space_id: "F0746S9DU3E",
    title: "hello world!",
    ...
}`,
    },
    {
        cat: 'task',
        desc: 'Read <b>Tasks</b> and <b>Events</b> with one API and unified data models',
        code: `GET /task/{connection_id}/note

{
    task_id: "F0746S9DU3E",
    title: "hello world!",
    ...
}`,
    },
    {
        cat: 'analytics',
        desc: 'List, Get, Update, Create, and Delete <b>Properties</b>, <b>Events</b>, <b>Sessions</b>, <b>Visitors</b>, and <b>Reports</b> with one API and unified data models',
        code: `GET /analytics/{connection_id}/event

{
    id: "12345",
    name: "page_view",
    event_type: "PAGE_VIEW",
    visitor_id: "67890",
    page_url: "https://example.com/pricing",
    utm_source: "google",
    utm_campaign: "spring_sale",
    ...
}

GET /analytics/{connection_id}/report

{
    property_id: "12345",
    start_at: "2024-01-01",
    end_at: "2024-01-31",
    metrics: [
        { type: "SESSIONS", value: 12450 },
        { type: "PAGE_VIEWS", value: 38200 },
        { type: "BOUNCE_RATE", value: 0.42 },
        ...
    ]
}`,
    },
    {
        cat: 'clubs',
        desc: 'Read <b>Clubs</b> and <b>Members</b> with one API and unified data models',
        code: `GET /clubs/{connection_id}/members?group_id=12345

{
    group_id: "12345",
    name: "High Park Tennis Club",
    members: [
        {
            id: "12345",
            name: "John Smith",
            email: "john@foobar.com",
            ...
        }
    ],
    ...
}`,
    },
    {
        cat: 'cdp',
        desc: 'Read <b>Segments</b> and <b>Profiles</b> with one API and unified data models',
        code: `GET /cdp/{connection_id}/segment

{
    id: "12345",
    name: "Pricing Page visitors",
    description: "All visitors of the Pricing Page",
    ...
}`,
    },
    {
        cat: 'performance',
        desc: 'Set <b>performance goals</b> and <b>employee feedback</b> with one API and unified data models',
        code: `POST /performance/{connection_id}/goal

{
    name: "Sales Performance",
    description: "Meet or exceed sales target",
    ...
}`,
    },
    {
        cat: 'social',
        desc: 'Read <b>Posts</b> with one API and unified data models',
        code: `GET /social/{connection_id}/post

{
    id: "12345",
    title: "1st post",
    body: "hello world!",
    ...
}`,
    },
];
